var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('poster',{attrs:{"poster-list":_vm.posterList,"time-format":4,"page-path":_vm.pagePath,"module-key":_vm.moduleKey,"token":_vm.token}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }